"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRef } from "react";
import { cn } from "@/lib/utils";
import Bg_Dots from "~/public/assets/backgrounds/bg-dots.png";
import { HeroActions } from "./hero-actions";
import type { HeroSectionProps } from "./types";
import { usePageHeroAnimation } from "./use-page-hero-animation";
export function PageHeroLayout(t0) {
  const $ = _c(46);
  const {
    tag,
    title,
    description,
    image,
    textRight,
    imageAlt: t1,
    id,
    actions,
    hideProjectsActionOnMobile,
    imageWrapClassName,
    imageClassName,
    containerWrapperClassName,
    containerLeftClassName,
    tagClassName: t2
  } = t0;
  const imageAlt = t1 === undefined ? "" : t1;
  const tagClassName = t2 === undefined ? "tag" : t2;
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const imageWrapRef = useRef(null);
  const imageRef = useRef(null);
  const glowRef = useRef(null);
  const dotsRef = useRef(null);
  const textRightRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sectionRef,
      contentRef,
      imageWrapRef,
      imageRef,
      glowRef,
      dotsRef,
      textRightRef
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    handlePointerMove,
    handlePointerLeave
  } = usePageHeroAnimation(t3);
  let t4;
  if ($[1] !== image) {
    t4 = image && <div className="pointer-events-none absolute inset-0 overflow-hidden"><div ref={glowRef} className="absolute -top-24 -right-20 z-10 h-full w-full max-h-70 max-w-40 rounded-full bg-[linear-gradient(168.76deg,#2A0502_15.35%,#A43A1C_52.46%,#FF8C31_67.94%)] opacity-90 blur-[90px] md:-top-30 md:-right-50 md:max-h-80 md:max-w-160 md:blur-[180px]" /></div>;
    $[1] = image;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== image) {
    t5 = image && <Image ref={dotsRef} src={Bg_Dots} alt="Background decorativo" aria-hidden="true" className="pointer-events-none absolute max-md:top-0 right-0 z-20 h-full w-full max-h-60 max-w-90 object-cover will-change-transform md:bottom-0 md:max-h-150.5 md:max-w-144.5 max-md:scale-y-[-1]!" sizes="(max-width: 768px) 360px, 578px" width={3000} height={3000} />;
    $[3] = image;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== containerWrapperClassName) {
    t6 = cn("w-full pt-36 flex items-center justify-between gap-5 2xl:gap-12", containerWrapperClassName);
    $[5] = containerWrapperClassName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== containerLeftClassName) {
    t7 = cn("relative z-50 w-full max-md:pt-10 max-md:max-w-100", containerLeftClassName);
    $[7] = containerLeftClassName;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== tagClassName) {
    t8 = cn(tagClassName, "hero-webpart-tag");
    $[9] = tagClassName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8 || $[12] !== tag) {
    t9 = <p className={t8}>{tag}</p>;
    $[11] = t8;
    $[12] = tag;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== title) {
    t10 = <h1 className="title-1 hero-webpart-title">{title}</h1>;
    $[14] = title;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== description) {
    t11 = description && <p className="hero-description hero-webpart-description">{description}</p>;
    $[16] = description;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== actions || $[19] !== hideProjectsActionOnMobile) {
    t12 = <HeroActions actions={actions} hideProjectsActionOnMobile={hideProjectsActionOnMobile} />;
    $[18] = actions;
    $[19] = hideProjectsActionOnMobile;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t7 || $[25] !== t9) {
    t13 = <div ref={contentRef} className={t7}>{t9}{t10}{t11}{t12}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t7;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== image || $[28] !== imageAlt || $[29] !== imageClassName || $[30] !== imageWrapClassName) {
    t14 = image && <div ref={imageWrapRef} className={cn("relative z-40 w-full max-w-180 transform-gpu will-change-transform", "max-md:max-w-68 max-md:absolute max-md:top-0 max-md:right-0", imageWrapClassName)}><Image ref={imageRef} alt={imageAlt} className={cn("h-full! transform-gpu will-change-transform", imageClassName)} height={2000} priority={true} fetchPriority="high" sizes="(max-width: 768px) 272px, 720px" src={image} width={2000} /></div>;
    $[27] = image;
    $[28] = imageAlt;
    $[29] = imageClassName;
    $[30] = imageWrapClassName;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== textRight) {
    t15 = textRight && <div ref={textRightRef} className="flex items-center gap-14 text-xl max-md:text-base max-md:gap-4 max-md:ml-auto"><div className="block w-20 md:w-43 h-[1.2px] bg-gray-300 rotate-110" /><p className="text-gray-100/75 max-w-58 text-right">{textRight}</p></div>;
    $[32] = textRight;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== t6) {
    t16 = <div className="w-full container px-6 lg:px-18 3xl:px-24! max-md:pb-16"><div className={t6}>{t13}{t14}{t15}</div></div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== handlePointerLeave || $[40] !== handlePointerMove || $[41] !== id || $[42] !== t16 || $[43] !== t4 || $[44] !== t5) {
    t17 = <section ref={sectionRef} onPointerMove={handlePointerMove} onPointerLeave={handlePointerLeave} className="md:container-padding relative overflow-hidden bg-gray-1100" id={id}>{t4}{t5}{t16}</section>;
    $[39] = handlePointerLeave;
    $[40] = handlePointerMove;
    $[41] = id;
    $[42] = t16;
    $[43] = t4;
    $[44] = t5;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}